import HttpService from "../../HttpService";

// initial state
const state = {
    announcements: [],
    announcement: {},
    loading: false,
};

// getters
const getters = {
    announcements: state => state.announcements,
    announcement: state => state.announcement,
};

const actions = {
    getAllAnnouncements({commit}) {
        HttpService.getInstance()
            .get("announcement")
            .then(announcements => {
                commit('setAnnouncements', announcements)
            })
    },
    getAnnouncement({commit}, payload) {
        console.log("id", payload.id);
        HttpService.getInstance()
            .get(`announcement/${payload.id}`)
            .then(announcemnt => {
                commit('setAnnouncement', announcemnt);
            })
    }
};

const mutations = {
    setAnnouncements(state, announcements) {
        state.announcements = announcements;
    },
    setAnnouncement(state, announcement) {
        state.announcement = announcement;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}